import {
  type FC,
  type ReactNode,
} from 'react';

import {
  Navigate,
} from 'react-router-dom';

import {
  useAuth,
} from '@/contexts/AuthContext';

import type {
  UserRole,
} from '@/hooks/useUsers';

type RequireRoleProps = {
  roles: UserRole[];
  children: ReactNode;
};

const RequireRole: FC<
  RequireRoleProps
> = ({
  roles,
  children,
}) => {
  const {
    user,
    loading,
  } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-foreground-500">
        Verificando permissões...
      </div>
    );
  }

  if (
    !user ||
    !roles.includes(
      user.role
    )
  ) {
    return (
      <Navigate
        to="/dashboard"
        replace
      />
    );
  }

  return <>{children}</>;
};

export default RequireRole;
